import { useContext, useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { API_URL } from './../Config/constant';
import { LayoutContext } from '../Context/LayoutContext';
import { useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';

// Custom hook for authentication
const useAuthentication = () => {
  const {
    setApiToken,
    setMainLoader,
    setUserLoggedIn,
    setLogoUrl,
    setCompanyInfoLoaded,
    setCompanyName,
  } = useContext(LayoutContext);
  const hasAuthenticated = useRef(false);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Centralized Logout Function
  const logoutUser = (message = 'Your account is inactive. You have been logged out.') => {
    setUserLoggedIn(false);
    localStorage.clear();
    navigate('/');
    toast.error(message);
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const emailId = localStorage.getItem('emailId');
        if (!emailId) {
          logoutUser('Session expired, please login again.');
          return;
        }

        // Generate the token
        const generateToken = async () => {
          try {
            if (hasAuthenticated.current) return;
            hasAuthenticated.current = true;
            const response = await axios.post(API_URL + 'api/token', {
              username: emailId,
            });

            const newApiToken = response.data.token;
            setApiToken(newApiToken);
            return newApiToken;
          } catch (error) {
            logoutUser();
            throw error;
          }
        };

        // Get user details
        const getUser = async (apiToken) => {
          try {
            const response = await axios.post(
              API_URL + 'api/user-detail',
              {
                username: emailId,
              },
              {
                headers: {
                  Authorization: `Bearer ${apiToken}`,
                },
              }
            );

            const { data } = response.data;

            // Check if user is inactive
            if (data?.status === 'Inactive') {
              logoutUser();
              return null;
            }

            return data;
          } catch (error) {
            console.error('Error fetching user details:', error);
            throw error;
          }
        };

        // Use the functions
        const newApiToken = await generateToken();
        if (newApiToken) {
          const userData = await getUser(newApiToken);
          if (userData) {
            setUser(userData);
            setMainLoader(false);
          }
        } else {
          throw new Error('Failed to generate token');
        }
      } catch (error) {
        setError(error);
      }
    };

    const fetchCompanyInformation = async () => {
      try {
        const response = await axios.get(`${API_URL}api/company-information`);
        if (response.data.status === 200) {
          setCompanyName(response.data.company_information.CompanyName);
          setLogoUrl(response.data.company_information.company_logo);
          setCompanyInfoLoaded(true);
        } else {
          console.error('Failed to fetch company information');
        }
      } catch (error) {
        console.error('Error fetching company information:', error);
      }
    };

    fetchCompanyInformation().then(fetchUser);
  }, [setApiToken, setLogoUrl, setCompanyInfoLoaded, navigate, setUserLoggedIn]);
  //   useEffect(() => {
  //     if (user && user.status === "Inactive") {
  //       logoutUser ();
  //     }
  //   }, [user]);
  // // Check user status on location change
  // useEffect(() => {
  //   if (user && user.status === "Inactive") {
  //     logoutUser ();
  //   }
  // }, [location, user]);
  return { user, error };
};

export default useAuthentication;
